export const VIOLATIONS = 'VIOLATIONS';
export const VIOLATIONS_COUNT = 'VIOLATIONS_COUNT';
export const SELECTED_VIOLATION = 'SELECTED_VIOLATION';
export const APP_VIOLATION_BUSY = 'APP_VIOLATION_BUSY';
